import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { webinarActions } from '../ActionTypes';


export const fetchWebinar = () => async (dispatch) => {
  try {
    dispatch({
      type: webinarActions.WEBINAR_FETCH_START
    });
    const resData = await Service.GET({
      name: 'webinar',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: webinarActions.WEBINAR_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: webinarActions.WEBINAR_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};
export const saveWebinar = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData,
      OrderNumber: Number(formData.OrderNumber)
    };
    dispatch({
      type: webinarActions.WEBINAR_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'webinar',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: webinarActions.WEBINAR_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/webinar'; }, 1000);
  } catch (error) {
    dispatch({
      type: webinarActions.WEBINAR_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editWebinar = (webinarId) => async (dispatch, getState) => {
  try {
    const { webinarList } = getState().webinar;
    const data = webinarList.find((item) => item.Id === webinarId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: webinarActions.WEBINAR_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: webinarActions.WEBINAR_RESET_FORM });

export const deleteWebinar = (Id) => async (dispatch) => Service.DELETE({
  name: 'webinar',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchWebinar());
    return true;
  }
  throw new Error(res.message);
});
